import { render, staticRenderFns } from "./CASEFVMoreInfo.vue?vue&type=template&id=3cb06e3e&"
import script from "./CASEFVMoreInfo.vue?vue&type=script&lang=js&"
export * from "./CASEFVMoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./CASEFVMoreInfo.vue?vue&type=style&index=0&id=3cb06e3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VExpandTransition,VIcon,VSpacer})
